<template>
    <div class="bg-white">
    
        <div>
            <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
    
                <CRow style="height: 100vh; display: flex; justify-content: center; align-items: center;">
                    <CCol sm="12" md="6" lg="6">
                        <div v-if="this.Error == true" class="mt-1">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error: {{ Message }}</strong>
                            </CAlert>
                        </div>
                        <CCard class="p-2 b-20" style="margin-bottom:20%" v-if="showMain">
                            <div class="text-center">
                                <img :src="greet.logo" style="max-width:100px" class="text-center" />
                            </div>
    
    
                            <div v-if="showQuestion === true" class="text-center">
    
                                <!-- <label class="custom-12px-400 text-center font-inter text-inter">Q{{ questions.index }} :</label
                                      > -->
                                <br />
                                <label class="custom-24px-700 font-inter text-center font-color-6C6C6C">Welcome to <br />{{greet.companyName}}</label>
                                <p class="font-color-696969">{{ greet.greetingText }}</p>
                            </div>
    
    
    
                            <CCol sm="12" class="text-center mt-3">
                                <CButton class="custom-border-purple text-white" style="max-width:200px" @click="ShowQuestionSurvey()">Start
                                </CButton>
                            </CCol>
    
    
    
                        </CCard>
    
                        <CCol sm="12" v-if="showStartSurvey">
    
                            <CCard class="p-2 b-20">
    
    
    
                                <label class="custom-20px-500 text-center" v-if="showInstruction">{{ instructionText }}</label>
                                <div v-if="showQuestion === true" class="text-center">
                                    <!-- <label class="custom-12px-400 text-center font-inter text-inter">Question{{ questions.index }}</label
                  > -->
                                    <label class="custom-16px-600 font-inter text-center font-color-171717">Q{{ questions.index }}:{{ questions.question }}</label>
                                </div>
    
                                <label class="custom-20px-500 text-center" v-if="showQuestion2 === true">
    <!-- <label class="custom-24px-700 text-center font-inter text-inter">Question</label
                  > -->
                    <label class="custom-16px-600 font-inter text-center font-color-171717">Q:{{ question.question }}</label>
                                </label>
             
    
    
                            </CCard>
                              <CContainer class="p-0">
                                <CRow class="p-0">
                                    <CCol sm="12">
                                        <CCard class="p-2 b-20">
                                            <div v-if="!inputbytext && !showTextInput" class="video-container">
                                                <video :class="{ hideAfterStop: toggleVideo }" ref="videoElement" autoplay style="height:300px"></video>
                                                <div class="timer" v-if="isRecording">{{ formatTime(elapsedTime) }} / 02:00</div>
                                                <div class="button-container">
                                                    <CRow>
                                                        <CCol sm="4">
                                                            <button class="record-button" 
                                                            @click="toggleRecording(index)" 
                                                            :class="{ recording: isRecording }"
                                                            v-if="!hideRecordingButton">
        <i v-if="!isRecording" class="fas fa-play"></i>
        <i v-else class="fas fa-stop"></i>
      </button>
                                                        </CCol>
                                                    </CRow>
                                                </div>
                                            </div>
                                            <div v-if="inputbytext || showTextInput" class="p-1">
                                                <p class="custom-14px-600 text-left" style="color:#171717">Type your review</p>
                                                <CTextarea v-model="text" rows="9"></CTextarea>
                                            </div>
                                        </CCard>
                                        <CCol sm="12" class="text-center mt-3" v-if="!showTextInput">
                                            <h3 class="custom-18px-600 text-white" v-if="!isRecording && hideNextButton">Click <strong>Red Button</strong> to Start</h3>
<h3 class="custom-18px-600 text-white" v-if="!isRecording && !hideNextButton && index < 7">Click <strong>Next Button</strong> to go to the next question</h3>
<h3 class="custom-18px-600 text-white" v-if="isRecording">You can start to give feedback/survey. Click <strong>Green Button</strong> to stop</h3>

                                            <CButton class="badge-purple text-white p-2" style="width:100px;font-size:20px" @click="GoToNextQuestion(index)" :class="{ disabled: isNextButtonDisabled }" v-if="index < 7 && !hideNextButton">
                                                Next
                                            </CButton>
                                            <CButton class="custom-border-purple text-white" style="max-width:200px" @click="OpenHomepage()" v-else-if="index === 7">
                                                Close
                                            </CButton>
                                            <br /> <br /> <br />
                                        </CCol>
                                        <CCol sm="12" class="text-center mt-3" v-if="showTextInput">
                                            <CButton class="badge-purple text-white p-2" style="width:100px;font-size:20px" @click="submitAnswerAndGoToNext(index)" v-if="index < 7">
                                                Next
                                            </CButton>
                                            <CButton class="custom-border-purple text-white" style="max-width:200px" @click="OpenHomepage()" v-else>
                                                Close
                                            </CButton>
                                            <br /> <br /> <br />
                                        </CCol>
                                    </CCol>
                                </CRow>
                            </CContainer>
                        </CCol>
                    </CCol>
                </CRow>
                <br /> <br />
            </CCol>
    
    
    
        </div>
    
    
        <div v-if="isLanguagePopupVisible2" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Stay Updated with Exclusive Offers!</h3>
                    <h3 class="custom-16px-400 text-center">
                        Get the latest promotions sent directly to your phone or email.
                    </h3>
                </div>
                <CRow class="d-flex align-items-center justify-content-center text-center flex-column flex-sm-row">
                    <CCol sm="6" class="mb-3 mb-sm-0">
                        <CButton class="custom-border-purple text-white w-100" @click="OpenFeedback()">
                            <span class="ml-2 mr-2">Keep Me Informed</span>
                        </CButton>
                    </CCol>
                    <CCol sm="6">
                        <CButton class="badge-purple p-2" block @click="closePopup2()"><span class="ml-2 mr-2 font-color-928AFD">No, Thanks</span></CButton>
                    </CCol>
                </CRow>
    
    
    
    
            </div>
        </div>
    
        <div v-if="PopupFeedback" class="popup-all backdrop-all">
            <div class="popup-all1">
                <div class="text-right">
                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupFeedback" />
            </div>
                <!-- Popup content -->
                <div class="text-center">
                    <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Stay Connected</h3>
                    <h3 class="custom-16px-400 text-center">
                        Please enter your email and phone number below to receive our exclusive deals and updates.
                    </h3>
    
    
                </div>
                <label class="custom-14px-600 font-color-171717 text-left">Full Name</label>
                <input type="text" class="border-white-50px" placeholder="Your Fullname" v-model="FullName" />
                <label class="custom-14px-600 font-color-171717 text-left mt-3">Email<strong class="text-danger ml-2">*</strong></label> 
                <input type="text" class="border-white-50px" placeholder="Your Email Address" v-model="Email" />
                <!-- <div v-if="emailError" class="text-danger mt-1">Email is required.</div> -->
                <div v-if="emailError" class="text-danger mt-1">{{ emailErrorMessage }}</div>
             
               
                <!-- <label class="custom-14px-600 font-color-171717 text-left">Phone</label>
                    <CInput type="text" /> -->
                <label class="custom-14px-600 font-color-171717 text-left mt-3">Phone</label>
                <div class="border-white-50px">
                    <div class="card-grey-50px">
                        <img src="../assets/img/my.jpg" style="width: 22px; top: 4px; position: absolute;" />
                        <input type="NUMBER" class="input-no-border" style="color: #A3A3A3;" placeholder="0123344567" v-model="PhoneNumber" />
                    </div>
                </div>
    <CAlert show color="danger" v-if="Error===true">{{ Message }}</CAlert>
                <CButton class="custom-border-purple text-white mt-3" @click="SubmitFeedback" block><span class="ml-2 mr-2">{{ lblProcessing }}</span></CButton>
    
            </div>
        </div>
    
        <div v-if="SuccessPopup" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Success!</h3>
                    <h3 class="custom-16px-400 text-center">
                        Your survey review is succesfully added
                    </h3>
                </div>
    
                <CButton class="custom-border-purple text-white" @click="closeSuccessFeedback()" block><span class="ml-2 mr-2">Close</span></CButton>
    
    
            </div>
        </div>
    
        <div v-if="showConfirmationDialog" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-right">
                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupConfirmation" />
            </div>
                <div class="text-center">
                    <h3 class="custom-18px-700 text-center">
                        How do you prefer to share your feedback?
                    </h3>
                </div>
                <CButton class="badge-purple p-2" @click="allowCamera" block><img src="../assets/img/Video 2.png" style="max-width:20px" /><span class="ml-2 mr-2 font-color-928AFD">Video</span></CButton>
                <CButton class="badge-purple p-2" @click="denyCamera" block><img src="../assets/img/Voice.png" style="max-width:20px" /><span class="ml-2 mr-2 font-color-928AFD">Voice only</span></CButton>
                <CButton class="badge-purple p-2" @click="inputByText" block><img src="../assets/img/text.png" style="max-width:20px" /><span class="ml-2 mr-2 font-color-928AFD">By Text</span></CButton>
    
    
    
    
    
    
            </div>
        </div>
    
    
    
    
    
    
    
    
        <Footerlayout></Footerlayout>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/HeaderQR.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";
import ToggleCard from "../components/Toggle.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            backgroundUrNoArrow,
            mediaRecorder: null,
            recordedChunks: [],
            isRecording: false,
            toggleVideo: false,
            uploadProgress: 0,
            questions: {},
            index: 1,

            question: {},

            showQuestion: true,
            showQuestion2: false,
            isNextButtonDisabled: true,

            elapsedTime: 0,
            timerInterval: null,
            isLanguagePopupVisible2: false,
            PopupFeedback: false,
            rating: 0,
            comment: '',
            SuccessPopup: false,
            instructionText: "You will see the question once you click the record button.",
            showInstruction: "",
            checking: {},
            showConfirmationDialog: false,
            cameraAccessDenied: false,
            Error: false,
            user: {},
            userId: "",
            email: "",
            Message: "",
            showStartSurvey: false,
            showMain: true,
            greet: {},
            inputbytext: false,
            showTextInput: false,
            text: "",
            sessionId: "",

            hideNextButton: true,
            hideRecordingButton: false,
            ReceiptNo: "",
            voucher: null,
            lblProcessing: "Submit",

            emailError: false,


        };
    },
    async created() {
        AOS.init();
    },
    async mounted() {
        await this.getFirstQuestion();
        await this.GetGreeting();
        await this.GetVoucher();

    },
    methods: {

        toggle() {
            this.isActive = !this.isActive;
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async startRecording(index) {
            try {

                await this.GetCheckingUploadVideo(index, this.questions.sessionId);

                if (this.checking === false) {
                    this.showInstruction = false;

                    // Check if camera access was denied before
                    if (this.cameraAccessDenied) {
                        return this.startRecordingAudio(index); // Proceed with audio recording only
                    }

                    // Request video and audio stream
                    const stream = await navigator.mediaDevices.getUserMedia({
                        video: {
                            width: { ideal: 1280 },
                            height: { ideal: 720 },
                            frameRate: { ideal: 30 },
                        },
                        audio: {
                            echoCancellation: true,
                            noiseSuppression: true,
                            sampleRate: 44100,
                        },
                    });

                    // Set up the video element and media recorder
                    this.$refs.videoElement.srcObject = stream;
                    this.$refs.videoElement.muted = true;
                    this.mediaRecorder = new MediaRecorder(stream);

                    this.mediaRecorder.ondataavailable = (event) => {
                        if (event.data.size > 0) {
                            this.recordedChunks.push(event.data);
                        }
                    };

                    this.mediaRecorder.onstop = () => {
                        this.handleRecordingStop(index);
                    };

                    this.mediaRecorder.start();
                    this.isRecording = true;
                    this.isNextButtonDisabled = true;
                    this.elapsedTime = 0;
                    this.timerInterval = setInterval(() => {
                        this.elapsedTime++;
                        if (this.elapsedTime >= 120) {
                            this.stopRecording();
                        }
                    }, 1000);

                    // Display the question when recording starts
                    // if (index === 1) {
                    //     this.showQuestion = true;
                    //     this.showQuestion2 = false;
                    // } else {
                    //     this.showQuestion2 = true;
                    //     this.showQuestion = false;
                    //     this.getListQuestion(index, this.questions.sessionId);
                    // }

                } else {
                    alert("Error. You already submitted this question. Please proceed to the next question by clicking the Next button.");
                }

            } catch (error) {
                console.error("Error accessing media devices: ", error);
                alert("Error accessing media devices. No device found.");
            }
        },

        async startRecordingAudio(index) {
    try {
        await this.GetCheckingUploadVideo(index, this.questions.sessionId);

        if (this.checking === false) {
            this.showInstruction = false;

            // Request audio-only stream
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    sampleRate: 44100,
                },
            });

            // Set up the media recorder for audio
            this.mediaRecorder = new MediaRecorder(stream);

            this.mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    this.recordedChunks.push(event.data);
                }
            };

            this.mediaRecorder.onstop = () => {
                this.handleRecordingStop(index);
            };

            this.mediaRecorder.start();
            this.isRecording = true;
            this.isNextButtonDisabled = true;
            this.elapsedTime = 0;
            this.timerInterval = setInterval(() => {
                this.elapsedTime++;
                if (this.elapsedTime >= 120) {
                    this.stopRecording();
                }
            }, 1000);

            // No need to fetch a new question or increment index here
        } else {
            alert("Error. You already submitted this question. Please proceed to the next question by clicking the Next button.");
        }
    } catch (error) {
        console.error("Error accessing media devices: ", error);
        alert("Error accessing media devices. No device found.");
    }
},


        allowCamera() {
            this.showConfirmationDialog = false;
            this.allowCameraAccess = true;
            this.cameraAccessDenied = false; // Reset the camera access denial status

            // Proceed with the existing logic to start recording
            this.startRecording(1);
        },

        denyCamera() {
            this.showConfirmationDialog = false;
            this.allowCameraAccess = false;
            this.cameraAccessDenied = true; // Mark camera access as denied
            //alert("Camera access denied.");
            this.startRecordingAudio(1);
        },

        stopRecording() {
        if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
            this.mediaRecorder.stop();
    
            if (this.$refs.videoElement.srcObject) {
                const tracks = this.$refs.videoElement.srcObject.getTracks();
                tracks.forEach((track) => track.stop());
            }
            this.$refs.videoElement.srcObject = null;
            this.recordedChunks = [];
            this.uploadProgress = 0;
            this.isRecording = false;
            clearInterval(this.timerInterval); // Stop the timer
            this.timerInterval = null;
            clearTimeout(this.stopRecordingTimeout);
            
        }

        // Enable the "Next" button
        this.isNextButtonDisabled = false;
        this.hideNextButton = false;  // Ensure button is not hidden
        console.log("Recording stopped. Next button enabled.");
    },

        handleRecordingStop(index) {
            const recordedBlob = new Blob(this.recordedChunks, {
                type: this.allowCameraAccess ? "video/webm" : "audio/webm",
            });

            this.recordedChunks = [];

            const formData = new FormData();
            formData.append("file", recordedBlob, this.allowCameraAccess ? "rekaman.webm" : "rekaman_audio.webm");
            formData.append("sessionId", this.questions.sessionId);
            formData.append("indexNo", index);
            formData.append("userId", this.userId);

            this.$API.post(this.$uploadFile, formData, {
                onUploadProgress: (progressEvent) => {
                    this.uploadProgress = Math.round(
                        (progressEvent.loaded / progressEvent.total) * 100
                    );
                },
            }).then((response) => {
                if (response.status === 200) {
                    this.videoId = response.data.videoId;
                    this.InsertVideoText(this.videoId);
                    console.log("Successfully uploaded.");
                } else {
                    console.error("Failed to upload.");
                }
            }).catch((error) => {
                console.error("Error:", error);
            });

            this.isNextButtonDisabled = false;
        },
        async GetCheckingUploadVideo(index, sessionId) {
            try {
                const response = await this.$API.get(this.$CheckVideoSessionIndex + "?sessionId=" + sessionId + "&indexNo=" + index);
                if (response.status === 200) {
                    this.checking = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        InsertVideoText(videoId) {

            this.$API
                .get(this.$ExtractAudioText + "/" + videoId)
                .then((response) => {

                    if (response.status == 200) {
                        console.log("success convert");
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },


       
        toggleRecording(index) {
    if (this.isRecording) {
        this.hideNextButton = false;
        this.stopRecording();
        this.hideRecordingButton = true;
    } else {
        if (index === 1 && !this.allowCameraAccess) {
            this.showConfirmationDialog = true;
        } else {
            this.hideNextButton = true;
            this.hideRecordingButton = false;
            // Start recording without affecting the question flow
            if (this.allowCameraAccess) {
                this.startRecording(index);
                this.hideRecordingButton = false;
            } else {
                this.hideRecordingButton = false;
                this.startRecordingAudio(index);
            }
        }
    }
},




async GoToNextQuestion(sessionId) {
    this.hideRecordingButton = false;
    this.hideNextButton = true;
    this.index++;

    // Control the display of questions
    this.showQuestion2 = true;
    this.showQuestion = false;

    // Fetch the next question based on the updated index
    console.log("sessionIdnextquestion" + this.questions.sessionId);
     await this.getListQuestion(this.index, this.questions.sessionId);
  

    // Re-enable the Next button after question is loaded
    this.isNextButtonDisabled = false;
},


        async getFirstQuestion() {
            try {
                const response = await this.$API.get(this.$GetFirstQuestionByQrCode + "?code=" + this.$route.query.code);

                if (response.status === 200) {
                    this.questions = response.data;
                    this.userId = response.data.userId;
                    this.email = response.data.email;
                    await this.tryLogin(); // Use await to handle any errors in tryLogin
                } else {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = response.data || 'An error occurred';
                }
            } catch (error) {
                this.Loading = false;
                this.Error = true;
                this.Message = error.response?.data || 'An error occurred';
            }
        },

        async tryLogin() {
            try {
                const formData = new FormData();
                formData.append("Email", "defaultuser@gmail.com");
                formData.append("Password", "Cellnet777#");

                const response = await this.$API.post(this.$LoginToken, formData, { withCredentials: true });

                if (response.status === 200) {
                    this.GetInfoUser();
                } else {
                    // Handle non-200 status here if needed
                }
            } catch (error) {
                this.Loading = false;
                this.Error = true;
                this.Message = error.response?.data?.message || 'An error occurred during login';
            }
        },

        async getListQuestion(index, sessionId) {
            this.showQuestion = false;
            if (index > 6) {
                this.stopRecording();
                this.isLanguagePopupVisible2 = true;
                this.InsertReport();
            } else {
                try {
                    const codeCompany = this.$route.query.code;

                    if (codeCompany != null) {
                        const response = await this.$API.get(
                            `${this.$GetNextQuestionByCode}?sessionId=${sessionId}&indexNo=${index}&code=${codeCompany}`, {
                                withCredentials: true,
                            }
                        );
                        if (response.status === 200) {
                                // const response = await this.$API.get(
                                //     `${this.$GetNextQuestionByCode}?sessionId=${sessionId}&indexNo=${index+1}&code=${codeCompany}`, {
                                //         withCredentials: true,
                                //     });
                                // this.question = response.data;
                                // this.showQuestion = false;

                    // Automatically move to the next question if "Skip"
                    if (response.data === 'Skip') {
                        this.showQuestion = false;
                    // Automatically move to the next question if "Skip"
                    await this.GoToNextQuestion(sessionId);
                } else {
                    // If valid question is returned, show the question
                    this.question = response.data;
                    this.showQuestion = false;
                    this.isNextButtonDisabled = false;
                }
                                



                        } else {
                            this.SuccessPopup = true;
                        }

                    } else {
                        const response = await this.$API.get(
                            `${this.$GetNextQuestion}/${sessionId}/${index}`, {
                                withCredentials: true,
                            }
                        );
                        if (response.status === 200) {
                            this.question = response.data;
                            this.showQuestion = false;
                        } else {}

                    }
                } catch (error) {}
            }
        },
        SubmitData() {

            const field = this.$route.query.field;
            const expertise = this.$route.query.expertise;

            const formData = new FormData();

            formData.append("email", this.email);
            formData.append("experties", expertise);
            formData.append("field", field);

            this.$API
                .post(this.$RegisterInterest, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {
                                this.isLanguagePopupVisible2 = true;
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenHomepage() {
            this.SignOut();
            this.SuccessPopup = true;

        },
        SignOut: function() {
            return this.$API
                .get(this.$SignOut, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        //this.$router.push("/Login");
                    }
                });
        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        },
        closePopup2() {
            this.isLanguagePopupVisible2 = false;
            this.$router.push("SubmissionSuccess");
        },
        OpenFeedback() {
            this.isLanguagePopupVisible2 = false;
            this.PopupFeedback = true;
        },
        updateStars(index) {
            this.rating = index;
        },
        getStarSrc(index) {
            return index <= this.rating ? require('../assets/img/star-yellow.png') : require('../assets/img/star-grey.png');
        },
        async GetVoucher() {
            try {
                const response = await this.$API.get(this.$GetVoucherByCode + "?code=" + this.$route.query.code);
                if (response.status === 200) {
                    this.voucher = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        validateEmail() {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.Email) {
        this.emailError = true;
        this.emailErrorMessage = 'Email is required.';
      } else if (!emailPattern.test(this.Email)) {
        this.emailError = true;
        this.emailErrorMessage = 'Please enter a valid email address.';
      } else {
        this.emailError = false;
        this.emailErrorMessage = '';
      }
    },
        SubmitFeedback() {

            this.validateEmail();
      
      // Prevent submission if email is invalid
      if (this.emailError) {
        return;
      }

          
           // this.PopupFeedback = false;
           this.lblProcessing = "Processing...";
            const formData = new FormData();
            formData.append("email", this.Email);
            formData.append("phoneNumber", this.PhoneNumber);
            formData.append("fullName", this.FullName);
            formData.append("sessionId", this.questions.sessionId);

            this.$API
                .post(this.$InsertConnectedUser, formData)
                .then((response) => {
                    if (response.status == 200) {
                            this.SuccessPopup = true;
                            this.voucherId = response.data.voucherno;
                            if(response.data.status === 0)
                            {
                                this.SuccessPopup = true;
                            }
                            else{
                                this.$router.push("Voucher?code=" + this.voucherId + "&status=" + response.data.status);
                            }
                           
                      
                    } else {
                        this.SignOut();
                        this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccessFeedback() {
            this.SuccessPopup = false;
            this.$router.push("SubmissionSuccess");
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        ShowQuestionSurvey() {
            this.showMain = false;
            this.showStartSurvey = true;
        },
        async GetGreeting() {
            try {
                const response = await this.$API.get(this.$GetGreeting + "?code=" + this.$route.query.code);
                if (response.status === 200) {
                    this.greet = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        inputByText() {
            this.showConfirmationDialog = false;
            this.inputbytext = true; // Set this to true to show the text input
            this.showTextInput = true; // Ensure the text input is shown
            this.toggleVideo = true; // Hide the video container
        },
        async submitAnswerAndGoToNext(index, sessionId) {
            try {
                this.sessionId = sessionId;
                await this.GetCheckingUploadVideo(index, this.questions.sessionId);


                if (!this.checking) {
                    const formData = new FormData();
                    formData.append("sessionId", this.questions.sessionId);
                    formData.append("indexNo", index);
                    formData.append("text", this.text);

                    const response = await this.$API.post(this.$StoreAnswerByText, formData, { withCredentials: true });

                    if (response.status === 200) {
                        this.index++;

                        if (this.index === 1) {
                            this.showQuestion = true;
                            this.showQuestion2 = false;
                        } else {
                            this.text = "";
                            this.showQuestion2 = true;
                            this.showQuestion = false;
                            await this.getListQuestion(this.index, this.questions.sessionId);

                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                } else {
                    this.index++;
                    this.text = "";
                    this.showQuestion2 = true;
                    await this.getListQuestion(index, this.questions.sessionId);
                }
            } catch (error) {
                this.Loading = false;
                this.Error = true;
                this.Message = error.response?.data?.message || "An error occurred.";
            }
        },
        async InsertReport() {
  
    try {
        const response = await this.$API.get(`${this.$GenerateReport}?session_id=`+ this.questions.sessionId);
        if (response.status === 200) {
           
          
        } else {
          
        }
    } catch (error) {
       
    }
},
closePopupConfirmation()
{
    this.showConfirmationDialog = false;
},
closePopupFeedback()
{
    this.PopupFeedback = false;
    this.$router.push("SubmissionSuccess")
},



    },
};
</script>

<style scoped>
@import url("https://fonts.cdnfonts.com/css/general-sans");
body {
    top: 0 !important;
    font-family: "General Sans", sans-serif;
}

.video-container {
    position: relative;
    width: 100%;
    background-color: black;
    border-radius: 21px;
    max-width: 100%;
}

.button-container {
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.record-button {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #f44336;
    color: white;
    font-size: 24px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.record-button:hover {
    background-color: #d32f2f;
}

.record-button.recording {
    background-color: #8bc34a;
}

.record-button i {
    margin-top: 8px;
}

.hideAfterStop {
    display: none;
}

video {
    border-radius: 21px;
    width: 100%;
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.timer {
    position: absolute;
    top: 24px;
    right: 0px;
    -webkit-transform: translateX(-20%);
    transform: translateX(-20%);
    font-size: 20px;
    color: white;
    background: #F02222;
    padding: 5px 10px;
    border-radius: 17px;
}

@media (max-width: 768px) {
    .popup-all1 {
        width: 90%;
        max-width: 500px;
        padding: 20px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 20px;
        z-index: 1000;
        margin: 0 auto;
        margin-top: 10%;
    max-height: 90vh;
    overflow-y: auto;
    scrollbar-width: none;
    }
}
</style>
